import React from 'react'
import { LogoMark } from './Logo'

export function LoadingScreen() {
  return (
    <div className="app-loading-screen" role="status" aria-label="Loading">
      <LogoMark size={48} className="app-loading-mark" />
    </div>
  )
}
